import { Platform, useWindowDimensions } from 'react-native';

import { NonProfitOrgProfileResponse } from '@/api/models/nonProfitOrgModels';
import { safeJsonParseArray } from '@/utils/firebaseImage';

import DetailsHeaderCarousel from '../DetailsHeaderCarousel';
import DetailsHeaderGallery from '../web/DetailsHeaderGallery.web';

type animatedOpacityStyle = {
  opacity: number;
};

interface DetailHeaderProps {
  data: NonProfitOrgProfileResponse;
  animatedOpacityStyle?: animatedOpacityStyle;
}

const NpoProfileHeader = ({ data, animatedOpacityStyle }: DetailHeaderProps) => {
  const { width: windowWidth } = useWindowDimensions();

  const thumbnails = safeJsonParseArray(data?.thumbnail ?? '[]');

  if (Platform.OS === 'web' && windowWidth > 768 && thumbnails.length > 1) {
    return (
      <DetailsHeaderGallery
        thumbnails={thumbnails}
        animatedOpacityStyle={{ opacity: 1 }}
        lightRatingValues={{
          name: data?.name ?? '-',
          ranking: parseFloat(data?.lightRaitingScore ?? '0')
        }}
      />
    );
  }

  return (
    <DetailsHeaderCarousel
      thumbnails={thumbnails}
      animatedOpacityStyle={Platform.OS === 'web' ? { opacity: 1 } : (animatedOpacityStyle ?? { opacity: 1 })}
      lightRatingValues={{
        name: data?.name ?? '-',
        ranking: parseFloat(data?.lightRaitingScore ?? '0')
      }}
    />
  );
};

export default NpoProfileHeader;
